/**
 * WorkspaceRoutes — nested routes for the Workspace module, mounted at
 * /<role>/workspace/* in each role layout. Mirrors the SettingsRoutes pattern.
 */
import { Routes, Route } from "react-router-dom";
import PermissionRoute from "./PermissionRoute";

import WorkspaceLayout from "../pages/Workspace/WorkspaceLayout";
import WorkspaceDashboard from "../pages/Workspace/WorkspaceDashboard";
import ProjectsList from "../pages/Workspace/ProjectsList";
import ProjectDetail from "../pages/Workspace/ProjectDetail";
import GlobalTasks from "../pages/Workspace/GlobalTasks";
import ClientsList from "../pages/Workspace/ClientsList";
import ClientDetail from "../pages/Workspace/ClientDetail";
import Timesheets from "../pages/Workspace/Timesheets";
import Analytics from "../pages/Workspace/Analytics";
import TeamsList from "../pages/Workspace/TeamsList";
import CanvasList from "../pages/Workspace/canvas/CanvasList";
import CanvasEditor from "../pages/Workspace/canvas/CanvasEditor";

const WorkspaceRoutes = () => (
  <Routes>
    <Route element={<WorkspaceLayout />}>
      <Route
        index
        element={
          <PermissionRoute permission="view_workspace">
            <WorkspaceDashboard />
          </PermissionRoute>
        }
      />
      <Route
        path="projects"
        element={
          <PermissionRoute permission="view_workspace">
            <ProjectsList />
          </PermissionRoute>
        }
      />
      <Route
        path="projects/:id"
        element={
          <PermissionRoute permission="view_workspace">
            <ProjectDetail />
          </PermissionRoute>
        }
      />
      <Route
        path="tasks"
        element={
          <PermissionRoute permission="view_workspace">
            <GlobalTasks />
          </PermissionRoute>
        }
      />
      <Route
        path="clients"
        element={
          <PermissionRoute permission="manage_clients">
            <ClientsList />
          </PermissionRoute>
        }
      />
      <Route
        path="clients/:id"
        element={
          <PermissionRoute permission="manage_clients">
            <ClientDetail />
          </PermissionRoute>
        }
      />
      {/* Teams had been gated on `manage_clients` — an unrelated key that
          happened to be held by the same people. It has its own key now. */}
      <Route
        path="teams"
        element={
          <PermissionRoute permission="manage_workspace_teams">
            <TeamsList />
          </PermissionRoute>
        }
      />
      <Route
        path="timesheets"
        element={
          <PermissionRoute permission="view_workspace">
            <Timesheets />
          </PermissionRoute>
        }
      />
      <Route
        path="canvas"
        element={
          <PermissionRoute permission="view_workspace">
            <CanvasList />
          </PermissionRoute>
        }
      />
      <Route
        path="analytics"
        element={
          <PermissionRoute permission="view_workspace_analytics">
            <Analytics />
          </PermissionRoute>
        }
      />
    </Route>

    {/* Editor is full-screen (takes over the viewport) — mounted OUTSIDE
        WorkspaceLayout so it has no page header / bottom tab bar. */}
    <Route
      path="canvas/:id"
      element={
        <PermissionRoute permission="view_workspace">
          <CanvasEditor />
        </PermissionRoute>
      }
    />
  </Routes>
);

export default WorkspaceRoutes;
